











import { FormElement } from '@/models/Form';
import { Component, Prop, Vue } from 'vue-property-decorator';
import ElementBase from './ElementBase.vue';

@Component({
    name: 'ElementStaticText',
    components: {
        'element-base': ElementBase,
    },
})
export default class ElementStaticText extends Vue {
    @Prop() element!: FormElement;

    submit() {
        this.$store.commit('addAnswer', { elementId: this.element.id, answer: [] });
        this.$store.dispatch('submit');
    }
}
